import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

interface FormActionsProps {
  isFirstSection: boolean;
  isLastSection: boolean;
  handlePrevious: () => void;
  handleNext: () => void;
  submitLoading: boolean;
  cancelForm: () => void;
  formSubmitted: boolean;
  updateFormState: any;
}

const FormActions: React.FC<FormActionsProps> = ({
  isFirstSection,
  isLastSection,
  handlePrevious,
  handleNext,
  submitLoading,
  cancelForm,
  formSubmitted,
  updateFormState,
}) => {
  // get tax payer id from localStorage

  // handle change for submit button
  const onSubmit = () => {
    let submitform;
    if (formSubmitted === false) {
      updateFormState();
    }
    return submitform;
  };

  return (
    <div className="form-actions">
      <Button label="Clear" icon="pi pi-times" className="p-button-outlined" style={{ overflow: "visible" }} onClick={cancelForm} />

      <div className="navigation-buttons">
        {!isFirstSection && <Button label="Previous" icon="pi pi-arrow-left" className="p-button-outlined" onClick={handlePrevious} />}

        {!isLastSection ? (
          <Button label="Next" icon="pi pi-arrow-right" iconPos="right" className="next-button" onClick={handleNext} />
        ) : (
          <Button label="Submit Form" icon="pi pi-check" className="common-primary-button" loading={submitLoading} onClick={onSubmit} />
        )}
      </div>
    </div>
  );
};

export default FormActions;
